import { Chip } from "@mui/material";
import Constants from "../../../../utils/constants.js";

function TourneeStatutBadge({ totalALaver, totalBacsLaves, totalBacsImpossible, sx = {} }) {

    let color, label;

    if (totalALaver <= (totalBacsLaves + totalBacsImpossible)) {
        color = Constants.COLOR_THEME_GREEN;
        label = "Terminé";
    } else if (totalBacsLaves > 0 || totalBacsImpossible > 0) {
        color = Constants.COLOR_THEME_BLUE;
        label = "En cours";
    } else {
        color = "grey";
        label = "Pas démarré";
    }

    return (
        <Chip
            label={label}
            sx={{
                backgroundColor: color,
                color: "white",
                marginRight: "2rem",
                ...sx
            }}
        />
    );
}


export default TourneeStatutBadge;
